import { useSearchParams } from 'libs/router'
import { getQueryStringFromUrl } from 'utils/getQueryStringFromUrl'

export const usePagination = () => {
	const [, setSearchParams] = useSearchParams()

	const handlePagination = (url: string) => {
		const newParams = getQueryStringFromUrl(url)
		setSearchParams(new URLSearchParams(newParams))
	}

	return {
		handlePagination
	}
}
